module.exports = __webpack_public_path__ + "static/media/company-benefit.e535d333.svg";